import { Box, Button, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import Productmobile from "../../Assets/Images/Product-mobile.png";
import rightArrow from "../../Assets/Images/right-arrow.png";
import LeftArrow from "../../Assets/Images/left-arrow.png";
import cardimage from "../../Assets/Images/cardimage.jpg";
import mobilemockup from "../../Assets/Images/mobile_mockup.png";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import parse from "html-react-parser";
import { CLEAR_BULLETIN_SUCCESS, createBulletinDataAction, updateBulletinDraftDetailAction } from '../../Redux/Actions/BulletinAction';
import { useErrorHandler } from '../../hooks';

const BulletinPreview = () => {
    const { bulletinDetail, isEdit, loading } = useSelector(
        (state) => state?.Bulletin
    );
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { setMsgConfig } = useErrorHandler();
    const [image, setImage] = useState("")
    const [navigateRoute, setNavigateRoute] = useState("SANDBOX");
    useEffect(() => {
        if (isEdit && typeof bulletinDetail?.cover_img === "string") {
            setImage(bulletinDetail?.cover_img ? bulletinDetail?.cover_img : "")
        }
        else {
            setImage(bulletinDetail?.cover_img ? URL.createObjectURL(bulletinDetail?.cover_img) : "")
        }
    }, [bulletinDetail?.cover_img])
    const uploadSandBox = () => {
        if (!isEdit) {
            setNavigateRoute("SANDBOX");
            const data = new FormData();
            data.append("title", bulletinDetail?.title);
            data.append("contributor_name", bulletinDetail?.contributor_name);
            data.append("short_desc", bulletinDetail?.short_desc);
            data.append("full_desc", bulletinDetail?.full_desc);
            data.append(
                "content_file_duration",
                bulletinDetail?.content_file_duration
            );
            data.append(
                "cover_img",
                bulletinDetail?.cover_img ? bulletinDetail.cover_img : null
            );
            data.append(
                "content_file",
                bulletinDetail?.content_file
                    ? bulletinDetail.content_file
                    : null
            );
            dispatch(createBulletinDataAction(data));
            if (!loading) {
                setMsgConfig({
                  alertOpen: true,
                  message: "Content Added successfully!",
                  severity: "success",
                  autoHideDuration: 2000,
                });         
                dispatch({ type: CLEAR_BULLETIN_SUCCESS });
                navigate("/bulletin", { state: navigateRoute });
              }            
        } else {
            const data = new FormData();
            data.append("Id", bulletinDetail?.Id);
            data.append("title", bulletinDetail?.title);
            data.append("contributor_name", bulletinDetail?.contributor_name);
            data.append("short_desc", bulletinDetail?.short_desc);
            data.append("full_desc", bulletinDetail?.full_desc);
            data.append(
                "content_file_duration",
                bulletinDetail?.content_file_duration
            );
            data.append(
                "cover_img",
                bulletinDetail?.cover_img ? bulletinDetail?.cover_img : null
            );
            data.append(
                "content_file",
                bulletinDetail?.content_file
                    ? bulletinDetail?.content_file
                    : null
            );
            dispatch(updateBulletinDraftDetailAction(data));
            if (!loading) {
                setMsgConfig({
                  alertOpen: true,
                  message: "Content Added successfully!",
                  severity: "success",
                  autoHideDuration: 2000,
                });         
                dispatch({ type: CLEAR_BULLETIN_SUCCESS });
                navigate("/bulletin", { state: navigateRoute });
              }            
        }
    }
    return (
        <>
            <Grid container spacing={3}>
                <Box className="mobile-section">
                    <img src={mobilemockup} className="product-image" alt="" />
                    <Box className="mobile-scroll">
                        <Box className="intgretive_wrp">
                            <Box className="card_image">
                                <img src={image} alt="" />
                            </Box>

                            <Box className="intgretive_details">
                                <Typography variant='h6'>
                                    {bulletinDetail?.title}
                                </Typography>

                                <Typography>
                                    {bulletinDetail?.short_desc}
                                </Typography>
                                {bulletinDetail?.full_desc
                                    ? parse(
                                        bulletinDetail?.full_desc
                                            ?.replace(
                                                "<img",
                                                `<center><img width="100%" height="100%"`
                                            )
                                    )
                                    : ""}
                            </Box>
                        </Box>

                    </Box>
                </Box>

                <Grid item xs={12}>
                    <Button
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "10px",
                            lineHeight: "0px",
                            padding: "13px 30px !important",
                        }}
                        variant="contained"
                        className="program-previous-btn"
                        onClick={() => navigate("/bulletin/create")}
                    >
                        <img src={LeftArrow} alt="" />
                        <span>Previous</span>
                    </Button>
                    <Button
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "10px",
                            lineHeight: "0px",
                            padding: "13px 30px !important",
                        }}
                        className="program-next-btn"
                        variant="contained"
                        onClick={uploadSandBox}
                    >
                        <span>UPLOAD TO SANDBOX</span>
                        <img src={rightArrow} alt="" />
                    </Button>
                </Grid>
            </Grid>
        </>
    )
}

export default BulletinPreview
